import { cx } from '@linaria/core';
import { Link } from '@provider/navigation';
import { ArrowButton, Cell } from '@ui/kit';
import { link, content, label, value } from './atom.trigger.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function Trigger(props) {
  return /*#__PURE__*/jsx(Link, {
    ref: props.ref,
    href: props.disabled ? undefined : props.navigateTo,
    className: link,
    "aria-disabled": props.disabled,
    "aria-label": props["aria-label"],
    tabIndex: 0,
    children: /*#__PURE__*/jsx(ArrowButton, {
      as: "div",
      children: /*#__PURE__*/jsxs("div", {
        className: content,
        children: [/*#__PURE__*/jsx("span", {
          className: label,
          children: props.label
        }), /*#__PURE__*/jsx(Cell
        // eslint-disable-next-line jsx-a11y/aria-role
        , {
          role: "unset",
          className: cx(value, props.value && "hasValue"),
          children: props.value || "Vælg"
        })]
      })
    })
  });
}

export { Trigger };
//# sourceMappingURL=atom.trigger.js.map
